import { render, staticRenderFns } from "./OrderToBeReceived.vue?vue&type=template&id=77d8d0f7&scoped=true&"
import script from "./OrderToBeReceived.vue?vue&type=script&lang=js&"
export * from "./OrderToBeReceived.vue?vue&type=script&lang=js&"
import style0 from "./OrderToBeReceived.vue?vue&type=style&index=0&id=77d8d0f7&lang=less&scoped=true&"
import style1 from "./OrderToBeReceived.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8d0f7",
  null
  
)

export default component.exports